import { AfterViewInit, Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import * as _ from 'lodash';

import { Ticket } from '@data/models/ticket.model';
import { buildPageSizeOptions } from '@shared/utils/utilities';
import { Project } from '@data/models/project.model';

const DEFAULT_LIST_SIZE = 10;

@Component({

    selector: 'syn-tickets-table',
    templateUrl: 'tickets-table.component.html',
    styleUrls: ['tickets-table.component.scss']
})
export class TicketsTableComponent implements OnInit, AfterViewInit, OnChanges {

    @Input() tickets: Ticket[];
    @Input() projects: Project[];
    @Input() displayedColumns = ['id', 'subject', 'status', 'type', 'isPrivate', 'tags', 'createdAt'];
    @Input() message: string;
    @Input() pageSize: Number;
    @Input() pageSizeOptions: Number[] = [];

    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;

    dataSource: MatTableDataSource<Ticket>;
    showPaginator = false;

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
    }

    ngOnInit() {
        if (this.projects) {
            this.displayedColumns = ['id', 'subject', 'project', 'status', 'type', 'isPrivate', 'tags', 'createdAt'];
        }
        this.pageSizeOptions = buildPageSizeOptions(this.tickets);
        this.pageSize = this.pageSizeOptions.length === 0 ? 0 : DEFAULT_LIST_SIZE;
        this.dataSource = new MatTableDataSource<Ticket>(this.tickets || []);
        this.showPaginator = (this.tickets.length > DEFAULT_LIST_SIZE);
    }

    ngOnChanges() {
        if (this.tickets && this.dataSource) {
            this.dataSource.data = this.tickets;
        }
    }

    public getProject(id: string) {
        return _.find(this.projects, { id });
    }

    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }

    legibleDate(date: string): string {
        return new Date(date).toLocaleDateString();
    }
}
